import { render, staticRenderFns } from "./MemberPosts.vue?vue&type=template&id=6ce582e8&"
import script from "./MemberPosts.vue?vue&type=script&lang=js&"
export * from "./MemberPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports